import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

import { registerSchema } from "../../services/schema/registerSchema";

import { Form } from "../../components/Form";
import WarningText from "../../components/Warnings";
import ButtonStyle from "../../components/Link";
import LogoStyle from "../../components/Logo";

import { ContainerReg } from "./style";
import { UserContext } from "../../contexts/UserContext";

export interface iRegister {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  bio: string;
  contact: string;
  course_module: string;
}

const RegisterPage = () => {
  const { userRegister } = useContext(UserContext);

  const [loadButton, setLoadButton] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<iRegister>({
    resolver: yupResolver(registerSchema),
  });

  const createUser = async (data: iRegister) => {
    userRegister(data, setLoadButton);
  };

  return (
    <>
      <ContainerReg>
        <LogoStyle>Kenzie Hub</LogoStyle>
        <Link to="/">Voltar</Link>
      </ContainerReg>

      <Form onSubmit={handleSubmit(createUser)}>
        <h2>Crie sua conta</h2>
        <p>Rapido e grátis, vamos nessa</p>

        <div>
          <label htmlFor="name">Nome</label>
          <input
            id="name"
            type="text"
            placeholder="Digite seu nome"
            {...register("name")}
          />
          <WarningText>{errors.name?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="text"
            placeholder="Digite seu email"
            {...register("email")}
          />
          <WarningText>{errors.email?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="password">Senha</label>
          <input
            id="password"
            type="password"
            placeholder="Digite sua senha"
            {...register("password")}
          />
          <WarningText>{errors.password?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="confirmPassword">Confirmar Senha</label>
          <input
            id="confirmPassword"
            type="password"
            placeholder="Digite sua senha novamente"
            {...register("confirmPassword")}
          />
          <WarningText>{errors.confirmPassword?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="bio">Bio</label>
          <input
            id="bio"
            type="text"
            placeholder="Fale sobre você"
            {...register("bio")}
          />
          <WarningText>{errors.bio?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="contact">Contato</label>
          <input
            id="contact"
            type="text"
            placeholder="Opção de contato"
            {...register("contact")}
          />
          <WarningText>{errors.contact?.message}</WarningText>
        </div>

        <div>
          <label htmlFor="module">Selecionar módulo</label>
          <select id="module" {...register("course_module")}>
            <option value="modulo 1">Primeiro Módulo</option>
            <option value="modulo 2">Segundo Módulo</option>
            <option value="modulo 3">Terceiro Módulo</option>
            <option value="modulo 4">Quarto Módulo</option>
          </select>
        </div>

        <ButtonStyle type="submit" className="register" disabled={loadButton}>
          {loadButton ? "Cadastrando..." : "Cadastre-se"}
        </ButtonStyle>
      </Form>
    </>
  );
};

export default RegisterPage;
